import { Field, ObjectType } from '@nestjs/graphql'

@ObjectType()
export class InvoiceDto {
  @Field()
  id!: string

  @Field()
  description!: string

  @Field(t => Date)
  paidOn!: Date

  @Field()
  cardLast4!: string

  @Field({ nullable: true })
  cardType?: string

  @Field()
  downloadLink!: string

  @Field()
  status!: string

  @Field({ nullable: true })
  paymentFailedReason?: string

  @Field({ nullable: true })
  paymentFailedDescription?: string

  @Field({ nullable: true })
  paymentFailedType?: string
}
